export const ADDRESS_FIELDS = [
  'address_1',
  'address_2',
  'city',
  'state',
  'zip_code',
  'country',
];

export const MEDICARE_FIELDS = [
  'medicare_reason',
  'medicare_plan',
  'medicare_termination_date',
  'medicare_effective_date',
];

export const BASIC_INFO_FIELDS = [
  'first_name',
  'middle_name',
  'last_name',
  'name_suffix',
  'gender',
  'birthdate',
  'ssn',
  'relationship_code',
];

export const VERIFICATION_FIELDS = ['verification_expires_on'];
